/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
import errorCode from '../../errorCode'; // 進行後端error code提示
import router from '@/modules/FPKG-20000-Util/vueRouter'; // lists 使用的router
import $http from '@/modules/FPKG-20000-Util/prototypes/axios'; // 後端溝通
import $store from '@/modules/FPKG-50000-Vuex/index'; // lists 與axios溝通
import TimeFormater from '@/modules/FPKG-20000-Util/converter/timeFormater';


type crud = number // crud


// validate
class Modify {
  private request: any;

  constructor(request?: object) {
    this.request = request;
  }

  public async get(): Promise<object> {
    const params = this.request;
    const d = await $http.get('account/manage/info', { params });
    if (d.data.code === 0) {
      const result = d.data.response;
      const formatedDate = new TimeFormater({ value: result.p3_account.p3_ant_created_at });
      result.p3_account.p3_ant_created_at = formatedDate.result;
      result.p5_role_f = result.p5_role.map((x: { p5_role_id: any; }) => x.p5_role_id);

      if (result.profile.p3_account_profile) {
        result.p3_account.p3_ape_name = result.profile.p3_account_profile.p3_ape_name;
        const birthday = new TimeFormater({ value: result.profile.p3_account_profile.p3_ape_birthday });
        result.p3_account.p3_ape_birthday = birthday.result;
        result.p3_account.p3_ape_gender = result.profile.p3_account_profile.p3_ape_gender;
        result.p3_account.p3_ape_email = result.profile.p3_account_profile.p3_ape_email ? JSON.parse(result.profile.p3_account_profile.p3_ape_email || '[]') : [];
        result.p3_account.p3_ape_tel = result.profile.p3_account_profile.p3_ape_tel ? JSON.parse(result.profile.p3_account_profile.p3_ape_tel || '[]') : [];
      } else {
        result.p3_account.p3_ape_email = [];
        result.p3_account.p3_ape_tel = [];
      }


      return result;
    }
    try {
      throw errorCode(d.data);
    } catch (error) {
      return {};
    }
  }
}


export default Modify;
